import React from 'react';

/**
 * App-weite ErrorBoundary.
 *
 * Im Normalbetrieb völlig transparent: rendert einfach `children`.
 * Greift NUR, wenn ein Nachfahre beim Rendern/Lifecycle wirft — dann zeigt sie
 * eine schlichte Fehlermeldung mit Aktionen, statt dass die App komplett schwarz wird
 * (die App hat sonst keine Boundary; ein Render-Fehler hinterlässt sonst eine leere Seite).
 *
 * Bewusst ohne externe Abhängigkeiten und mit Inline-Styles, damit der Fallback
 * auch dann sichtbar ist, wenn das CSS/Theme nicht greift.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Für Diagnose in der Browser-Konsole (kein externer Versand).
    console.error('[Tresor ErrorBoundary]', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const wrap = {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: '#0b1220',
      color: '#e2e8f0',
      fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    };
    const card = {
      maxWidth: '460px',
      width: '100%',
      textAlign: 'center',
      background: '#111a2e',
      border: '1px solid #243049',
      borderRadius: '16px',
      padding: '32px 28px',
    };
    const btn = {
      display: 'inline-block',
      width: '100%',
      boxSizing: 'border-box',
      padding: '11px 16px',
      borderRadius: '10px',
      border: 'none',
      cursor: 'pointer',
      fontWeight: 700,
      fontSize: '14px',
      marginTop: '10px',
    };
    const primary = { ...btn, background: '#10b981', color: '#04221a' };
    const ghost = {
      ...btn,
      background: 'transparent',
      color: '#cbd5e1',
      border: '1px solid #334155',
      textDecoration: 'none',
    };

    return (
      <div style={wrap}>
        <div style={card}>
          <h1 style={{ fontSize: '22px', fontWeight: 800, margin: '0 0 10px' }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ fontSize: '14px', lineHeight: 1.6, color: '#94a3b8', margin: '0 0 22px' }}>
            Die Seite konnte nicht geladen werden. Bitte laden Sie sie neu. Ihre verschlüsselten
            Daten sind davon nicht betroffen.
          </p>
          <button type="button" style={primary} onClick={() => window.location.reload()}>
            Seite neu laden
          </button>
          <a style={ghost} href="https://datenputzer.de/dashboard">
            Zurück zu Datenputzer
          </a>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
